<!-- 预赛 -->
<template>
    <div v-if="winner" class="winner winner--final_1">
        <k-block name="winners_final_1" />
        <k-user :nick="winner.mobile" :logo="winner.logoSrc" />
    </div>
</template>

<script>
    export default {
        name: 'winner-final-1',
        props: ['winner']
    }
</script>
